import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '../Button';

import './Tabs.scss';

const Tabs = props => {
  const {
    border,
    className,
    content,
    defaultActiveTab,
    justify,
    onChange,
    showButtons,
    size,
    stickyNav,
    topRightContent,
  } = props;

  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const toggle = (tab, tabName) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      document.activeElement.blur();

      if (typeof onChange === 'function') {
        onChange(tab, tabName);
      }
    }
  };

  const borderClass = {
    bottom: 'bordered-bottom',
    top: 'bordered-top',
  };

  return (
    <div
      className={classnames(
        'tabs',
        { 'nav-justified': justify },
        borderClass[border],
        className,
        { 'tabs-sm': size === 'sm' },
        { 'tabs-lg': size === 'lg' }
      )}
    >
      <div className="tabs-wrap">
        <Nav
          tabs
          className={classnames({
            'sticky-nav': stickyNav,
          })}
        >
          {content.map((item, index) => (
            <NavItem key={`${1 + index}.link`}>
              {item.tabName && (
                <NavLink
                  className={classnames({
                    active: activeTab === index,
                  })}
                  onClick={() => toggle(index, item.tabName)}
                  tag="button"
                  type="button"
                  {...item.tabLinkProps}
                >
                  {item.tabName}
                </NavLink>
              )}
            </NavItem>
          ))}
          {topRightContent && (
            <div className="top-right-content">{topRightContent}</div>
          )}
        </Nav>
        <TabContent activeTab={activeTab}>
          {content.map((item, index) => (
            <TabPane key={`${1 + index}.content`} tabId={index}>
              {item.tabContent}
            </TabPane>
          ))}
        </TabContent>
      </div>
      {showButtons && (
        <div className="tab-buttons">
          <div>
            <Button
              color="secondary"
              disabled={activeTab === 0}
              onClick={() => toggle(activeTab - 1)}
            >
              Previous
            </Button>
          </div>
          <div>
            <Button
              color="primary"
              disabled={activeTab === content.length - 1}
              onClick={() => toggle(activeTab + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

Tabs.propTypes = {
  border: PropTypes.oneOf(['default', 'top', 'bottom']),
  className: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.node,
      tabContent: PropTypes.node,
    })
  ).isRequired,
  justify: PropTypes.bool,
  onChange: PropTypes.func,
  defaultActiveTab: PropTypes.number,
  showButtons: PropTypes.bool,
  stickyNav: PropTypes.bool,
  size: PropTypes.oneOf([null, 'sm', 'lg']),
  topRightContent: PropTypes.node,
};

Tabs.defaultProps = {
  border: null,
  className: null,
  justify: true,
  onChange: () => {},
  defaultActiveTab: 0,
  showButtons: false,
  stickyNav: false,
  size: null,
  topRightContent: null,
};

export default Tabs;
